import { Component, OnInit } from '@angular/core';
declare var $ : any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  year : any;
  constructor() { }

  ngOnInit() {
  }

  openDemo(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Demo Request');
  }

  openContact(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Contact Us');
  }

  getCurrentYear() {
    this.year = new Date().getFullYear();
    return `${this.year}`;
  }
}
